module.exports = __webpack_public_path__ + "static/media/group-12-copy@3x.8efc2862.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/group-12-copy@3x.png
// module id = 76
// module chunks = 19